/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Currency a prize pool or entry fee is denominated in. Note that a competition can be denominated in USD while the entrant actually pays FUEL — conversion happens at join time.
 * 
 * @export
 */
export const CompetitionCurrency = {
    USD: 'USD',
    FUEL: 'FUEL'
} as const;
export type CompetitionCurrency = typeof CompetitionCurrency[keyof typeof CompetitionCurrency];


export function instanceOfCompetitionCurrency(value: any): boolean {
    for (const key in CompetitionCurrency) {
        if (Object.prototype.hasOwnProperty.call(CompetitionCurrency, key)) {
            if (CompetitionCurrency[key as keyof typeof CompetitionCurrency] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompetitionCurrencyFromJSON(json: any): CompetitionCurrency {
    return CompetitionCurrencyFromJSONTyped(json, false);
}

export function CompetitionCurrencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionCurrency {
    return json as CompetitionCurrency;
}

export function CompetitionCurrencyToJSON(value?: CompetitionCurrency | null): any {
    return value as any;
}

export function CompetitionCurrencyToJSONTyped(value: any, ignoreDiscriminator: boolean): CompetitionCurrency {
    return value as CompetitionCurrency;
}

